import { LuminousGallery } from "luminous-lightbox";

const galleryNodes = document.querySelectorAll(".js-grid-gallery__content");
if (galleryNodes) {
  new LuminousGallery(galleryNodes);
}
